/* eslint-disable react/no-danger */
import React from 'react';
import './title-divided.scss';

function TitleDivided({
  className,
  smallTitleAbove,
  title,
  titleHighlighted,
  content,
  type = 'light-and-bold',
  inOneLine = false,
  htmlRaw = false,
}) {
  const division = inOneLine ? ' ' : <br />;
  const lightAndBold = (
    <h2>
      {title || content.title}
      {division}
      <strong>{titleHighlighted || content.titleHighlighted}</strong>
    </h2>
  );
  const boldAndLight = (
    <h2>
      <strong>{titleHighlighted || content.titleHighlighted}</strong>
      {division}
      {title || content.title}
    </h2>
  );
  let h2Title = type === 'light-and-bold' ? lightAndBold : boldAndLight;

  if (htmlRaw) {
    const finalTitle = `${title || content.title} <br /> ${titleHighlighted || content.titleHighlighted}`;
    h2Title = <h2 dangerouslySetInnerHTML={{ __html: finalTitle }} />;
  }
  return (
    <div className={className}>
      {(smallTitleAbove || content?.smallTitleAbove) && (
        <span className='title-divided-small-title-above'>{smallTitleAbove || content.smallTitleAbove}</span>
      )}
      {h2Title}
    </div>
  );
}

export default TitleDivided;
